const getInputElementTrimmedValue = (eventTarget: EventTarget) => {
  const element = eventTarget as HTMLInputElement
  return element.value && element.value.trim()
}

export { getInputElementTrimmedValue }
